import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { locations } from "@/data/locations";
import useScrollReveal from "@/hooks/useScrollReveal";

const StandorteSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section
      id="standorte"
      data-testid="standorte-section"
      ref={sectionRef}
      className="section-padding bg-white relative overflow-hidden"
    >
      <div className="absolute top-1/3 -left-40 w-96 h-96 bg-emerald-300/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 -right-40 w-96 h-96 bg-orange-200/10 rounded-full blur-3xl pointer-events-none" />

      <div className="container-custom relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-4">
            Mein Einsatzgebiet
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-6 font-[Outfit]">
            Thermomix® in deiner Stadt – Krefeld & 25 km Umkreis
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Ich bin für dich unterwegs – von Krefeld aus im ganzen 25km-Umkreis.
            Klicke auf deine Stadt für alle Details zur Vorführung in deiner Region.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 max-w-6xl mx-auto reveal">
          {locations.map((loc) => (
            <Link
              key={loc.slug}
              to={`/standort/${loc.slug}`}
              data-testid={`standort-card-${loc.slug}`}
              className="glass-card rounded-2xl p-5 hover:bg-emerald-50/40 hover:border-emerald-200 transition-all group relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-emerald-400/5 rounded-full blur-2xl group-hover:bg-emerald-400/20 transition-colors" />
              <div className="relative">
                <div className="flex items-center gap-1.5 mb-2">
                  <MapPin className="w-3.5 h-3.5 text-emerald-600" />
                  <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700">
                    {loc.distance_km === 0 ? "Hauptstandort" : `${loc.distance_km} km`}
                  </span>
                </div>
                <div className="font-bold text-slate-900 text-lg font-[Outfit] mb-1 group-hover:text-emerald-700 transition-colors">
                  {loc.name}
                </div>
                <div className="text-xs text-slate-500 mb-3 line-clamp-1">
                  {loc.stadtteile.slice(0, 3).join(" · ")}
                </div>
                <div className="flex items-center gap-1 text-xs text-emerald-600 font-semibold">
                  Zur Seite <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <p className="text-center mt-10 text-sm text-slate-500 reveal">
          Du wohnst nicht direkt in einer der Städte? Kein Problem –{" "}
          <a href="#contact" className="text-emerald-600 font-semibold hover:underline">
            frag einfach direkt an
          </a>
          , ich komme auch in die Nachbarorte.
        </p>
      </div>
    </section>
  );
};

export default StandorteSection;
